module.exports = __webpack_public_path__ + "static/media/HankHacker.ca5fdf7e.png";